import React, { PropTypes, Component } from 'react';
import $ from 'jquery';
import cx from 'classnames';

class Datepicker extends Component {
  componentDidMount() {
    const $picker =
      this.props && this.props.identifier
        ? $(`input.datepicker#${this.props.identifier}`)
        : $('input.datepicker');

    $picker.each((_, element) => {
      const $element = $(element);

      const orientation = $element.attr('data-orientation') || 'bottom';

      $element.attr('autocomplete', 'off');

      $element
        .datepicker({
          language: 'fr',
          autoclose: true,
          orientation,
        })
        .on('changeDate', evt => {
          this.props.onChange(evt);
        });
    });
  }

  render() {
    const {
      className,
      name,
      value,
      disabled,
      identifier,
      onChange,
      placeholder,
    } = this.props;

    return (
      <input
        id={identifier}
        type="text"
        className={cx('datepicker', className)}
        name={name}
        onChange={onChange}
        value={value || ''}
        disabled={disabled}
        placeholder={placeholder}
      />
    );
  }
}

Datepicker.propTypes = {
  identifier: PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.any,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
};

Datepicker.defaultProps = {
  className: '',
  disabled: false,
};

export default Datepicker;



// WEBPACK FOOTER //
// ./src/modules/common/components/Datepicker.js